export const toInteger = (value: number | undefined) => value && Math.round(value);
